export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()

    if (config.public.trustedShopsId && !document.getElementById('trustedshops')) {
        const script = document.createElement('script')
        script.id = 'trustedshops'
        script.src = `https://widgets.trustedshops.com/js/${config.public.trustedShopsId}.js`
        script.charset = 'UTF-8'
        script.async = true
        script.setAttribute('data-cmp-ab', '2')
        script.setAttribute('data-desktop-y-offset', '0')
        script.setAttribute('data-mobile-y-offset', '0')
        script.setAttribute('data-desktop-enable-custom', 'true')
        script.setAttribute('data-desktop-custom-width', '156')
        script.setAttribute('data-mobile-custom-width', '156')
        script.setAttribute('data-mobile-enable-custom', 'true')
        document.head.appendChild(script)
    }

    if (config.public.profitfinderId && !document.getElementById('profitfinder')) {
        const script = document.createElement('script')
        script.id = 'profitfinder'
        script.src = `https://members.profitfinder.app/scripts/${config.public.profitfinderId}.js`
        script.async = true
        script.setAttribute('data-cmp-ab', '2')
        document.head.appendChild(script)
    }
})
